module.exports = __webpack_public_path__ + "img/efecty.c8a34d9.svg";